export default __webpack_public_path__ + "static/media/law.7872a884.svg";